export enum AppRoute {
  Root = '/plant-assessment',
  AssessmentDetail = '/plant-assessment/:assessmentId',
  MediaDashboard = '/plant-assessment/media-dashboard',
  Demo = '/plant-assessment/:assessmentId/analytics/:assessmentAssetId',
  DemoSpectrum = '/plant-assessment/:assessmentId/analytics/:assessmentAssetId/spectrum/:sampleId',
  PublicDocument = '/document/:docId',
  Matrix = '/matrix'
}

export const paths = {
  root: () => AppRoute.Root,
  assessmentDetail: (assessmentId: string) => `/plant-assessment/${assessmentId}`,
  assessmentDocumentsAra: (assessmentId: string) =>
    `/plant-assessment/${assessmentId}?tab=documents&ara=1`,
  mediaDashboard: () => AppRoute.MediaDashboard,
  demo: (assessmentId: string, assessmentAssetId: string) =>
    `/plant-assessment/${assessmentId}/analytics/${assessmentAssetId}`,
  demoHealthReport: (assessmentId: string, assessmentAssetId: string) =>
    `/plant-assessment/${assessmentId}/analytics/${assessmentAssetId}/health-report`,
  demoAnalytics: (assessmentId: string, assessmentAssetId: string) =>
    `/plant-assessment/${assessmentId}/analytics/${assessmentAssetId}`,
  demoSpectrum: (
    assessmentId: string,
    assessmentAssetId: string,
    sampleId: string,
    type?: 'velocity' | 'acceleration' | 'envelope'
  ) =>
    `/plant-assessment/${assessmentId}/analytics/${assessmentAssetId}/spectrum/${sampleId}${type ? `?type=${type}` : ''}`,
  publicDocument: (docId: string) => `/document/${docId}`,
  matrix: () => AppRoute.Matrix
} as const

export type PathBuilder = typeof paths
